// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1Eey4","consentsList":"PatientConsents_consentsList__1EMwV","consentsListEmpty":"PatientConsents_consentsListEmpty__AMc7h"};